const metaData = require("./meta-data");
const validate = require("./validate");


module.exports = { metaData, validate };
